import { render, staticRenderFns } from "./UserBehavior.vue?vue&type=template&id=3b9d4b48&"
import script from "./UserBehavior.vue?vue&type=script&lang=js&"
export * from "./UserBehavior.vue?vue&type=script&lang=js&"
import style0 from "./UserBehavior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports